import { SystemSourceEnum } from "../services/http/auth.service";
import { DictionaryItem, DictionaryItemGuid } from "./shared/dictionaryItem.model";

export class UserCreateEdit {
    id:string = '00000000-0000-0000-0000-000000000000';
    companyName:string = "";
    officeAddress:string = "";
    firstName:string = "";
    lastName:string = "";
    phoneNumber:string = "";
    email:string = ""; 
    applications: DictionaryItemGuid[] = [];
    undertakings: any[] = [];
    utilityIds: number[] = [];
    twoFactorEnabled: boolean = false;
}

export class User {
    id:number = 0;
    dateCreated:any = null;
    name:string = "";
    role:string = "";
    roleId:number = 0;
    image:string = "";
    email:string = "";
    phoneNumber:string = "";
    status:string = ""; 
    systemSource: Number = SystemSourceEnum.BillingManagement;
    country:string = "";
    districtId:number = 0;
    districtName:string = "";
    regionIds: number[] = [];
    applications: DictionaryItemGuid[] = [];
    regionsNames:string = '';
    userGuid: string = '00000000-0000-0000-0000-000000000000';
    twoFactorEnabled: boolean = false;
}